import { PARTNER360_NAMESPACE } from 'legacy/lut/features/partner360/common/constants'

export const PARTNER360_FIN_SOB_NAMESPACE = `${PARTNER360_NAMESPACE}/finSobS`
